
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { NotShowIcon } from "@/utils/PlanRules";
import { CompositionType } from "@/types/PlansType";

@Component({
  name: "PlanDialog",
})
export default class PlanDialog extends Vue {
  @Prop({ default: false }) readonly showModal!: boolean;

  @Prop({ default: false }) readonly isBalanceAlert!: boolean;

  @Prop({ default: null }) readonly title!: string;

  @Prop({ default: "" }) readonly price?: string;

  @Prop({ default: null }) readonly internet!: string;

  @Prop({ default: null }) readonly email!: string;

  @Prop({ default: null }) readonly message!: string;

  @Prop({ default: false }) readonly paramBonus!: boolean;

  @Prop({ default: null }) readonly valorBonus!: string;

  @Prop({ default: null }) readonly id!: string;

  @Prop({
    default: () => [],
  })
  readonly compositions!: CompositionType[];

  @Getter tiktok!: string[];

  @Getter skeeloCompositionId!: string[];

  freeFireCompositionName = process.env.VUE_APP_FREE_FIRE_COMPOSITION_NAME;
  isShowService() {
    return NotShowIcon(this.id);
  }

  closeModal() {
    this.$emit("closeModal", true);
  }
}
